import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { Check } from "lucide-react";
import { Button } from "@themes/pollinator/ui/Button";

export type Props = {
  /** Additional CSS classes */
  className?: string;
  /** Click handler */
  onClick?: () => void;
  /** Whether the item is checked/selected */
  checked?: boolean;
  /** Item content */
  children?: ReactNode;
  /** Whether the item is disabled */
  disabled?: boolean;
  /** Test ID for testing */
  testId?: string;
};

/**
 * A dropdown menu item button, typically used inside a Dropdown component.
 */
export function DropdownButtonItem({
  className,
  children,
  checked,
  disabled,
  testId = "dropdown-button-item",
  onClick,
  ...rest
}: Props) {
  return (
    <Button
      variant="menu-item"
      className={twMerge(
        "justify-start w-full",
        checked && "bg-brand-100",
        className
      )}
      iconComponent={checked ? Check : undefined}
      data-testid={testId}
      disabled={disabled}
      onClick={onClick ? onClick : () => {}}
      {...rest}
    >
      {children}
    </Button>
  );
}

export default DropdownButtonItem;

